const SENSITIVE_KEY = /card|cvv|cvc|account|routing|expir|secur/i;

const redact = (value, depth) => {
  if (depth > 8 || value === null || typeof value !== 'object') return value;

  if (Array.isArray(value)) return value.map(item => redact(item, depth + 1));

  return Object.entries(value).reduce((acc, [key, item]) => {
    acc[key] = SENSITIVE_KEY.test(key) ? '[redacted]' : redact(item, depth + 1);

    return acc;
  }, {});
};

export const scrubBreadcrumb = breadcrumb => {
  if (breadcrumb.data) breadcrumb.data = redact(breadcrumb.data, 0);

  return breadcrumb;
};

// A promise rejected with a DOM event or an empty object, with no stack to say
// where. These come from browser extensions, password managers and third-party
// scripts, nothing in them points at our code, and a burst of them buries the
// errors that do.
const isAnonymousRejection = event => {
  const exception = event.exception?.values?.[0];
  const frames = exception?.stacktrace?.frames ?? [];

  return /^Non-Error promise rejection captured/.test(exception?.value ?? '') && frames.length === 0;
};

export const scrubEvent = event => {
  if (isAnonymousRejection(event)) return null;

  if (event.extra) event.extra = redact(event.extra, 0);
  if (event.contexts) event.contexts = redact(event.contexts, 0);
  if (event.request?.data) event.request.data = redact(event.request.data, 0);

  return event;
};
